import { ApiClient } from '../utils/api-client'
import { DietHistoryResponse, ProteinHistoryResponse } from '../types'

const API_CONFIG = {
  baseURL: process.env.REACT_APP_API_FOODBOT_BASE_URL || 'https://tatva-food-bot-uat.mytatva.in',
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }
}

const apiClient = new ApiClient(API_CONFIG)

export const dietService = {
  async getDietHistory(userId: string, page: number = 1, limit: number = 10): Promise<DietHistoryResponse> {
    try {
      const response = await apiClient.get<DietHistoryResponse>(
        '/food/history',
        {
          params: {
            user_id: userId,
            page,
            limit
          },
          requireAuth: false
        }
      )

      return response.data
    } catch (error: any) {
      console.error('Diet History API Error:', error)
      throw new Error(error.message || 'Failed to fetch diet history')
    }
  },

  async getProteinHistory(userId: string, page: number = 1, limit: number = 10): Promise<ProteinHistoryResponse> {
    try {
      const response = await apiClient.get<ProteinHistoryResponse>(
        '/protein/history',
        {
          params: {
            user_id: userId,
            page,
            limit
          },
          requireAuth: false
        }
      )

      return response.data
    } catch (error: any) {
      console.error('Protein History API Error:', error)
      throw new Error(error.message || 'Failed to fetch protein history')
    }
  },

  async deleteDietLog(userId: string, logId: string): Promise<void> {
    try {
      await apiClient.delete(
        '/food/delete',
        {
          params: {
            user_id: userId,
            session_id: logId
          },
          requireAuth: false
        }
      )
    } catch (error: any) {
      console.error('Delete Diet Log API Error:', error)
      throw new Error(error.message || 'Failed to delete diet log')
    }
  },

  async deleteProteinLog(userId: string, logId: string): Promise<void> {
    try {
      await apiClient.delete(
        '/protein/history',
        {
          params: {
            user_id: userId,
            log_id: logId
          },
          requireAuth: false
        }
      )
    } catch (error: any) {
      console.error('Delete Protein Log API Error:', error)
      throw new Error(error.message || 'Failed to delete protein log')
    }
  }
} 